import { Button } from "@/components/ui/button";
import { ConfettiEffect } from "./components/ConfettiEffect";
import { CompletionHeader } from "./components/CompletionHeader";
import { CompletionMessage } from "./components/CompletionMessage";
import { useCompletionHandler } from "./hooks/useCompletionHandler";
import { Trophy, Star, Flame } from "lucide-react";

export const WorkoutCompletion = () => {
  const { handleCompletion } = useCompletionHandler();

  return (
    <div className="animate-fade-in min-h-[100dvh] w-full overflow-y-auto flex items-start sm:items-center justify-center px-4 py-4 sm:py-8 relative">
      <ConfettiEffect />

      {/* Decorative background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-br from-yellow-500/10 via-primary/10 to-orange-500/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 space-y-4 sm:space-y-8 max-w-sm w-full text-center pb-8">
        {/* Trophy icon with glow */}
        <div className="relative w-20 h-20 sm:w-32 sm:h-32 mx-auto">
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-400/30 to-orange-500/30 rounded-full blur-2xl animate-pulse" />
          <div className="relative w-full h-full rounded-full bg-gradient-to-br from-yellow-400 to-orange-500 flex items-center justify-center shadow-2xl shadow-yellow-500/30 animate-scale-in">
            <Trophy className="h-10 w-10 sm:h-16 sm:w-16 text-white drop-shadow-lg" />
          </div>
          {/* Floating stars */}
          <Star className="absolute -top-2 -right-2 h-5 w-5 sm:h-6 sm:w-6 text-yellow-400 fill-yellow-400 animate-bounce" />
          <Star className="absolute -bottom-1 -left-3 h-4 w-4 sm:h-5 sm:w-5 text-yellow-400/80 fill-yellow-400/80 animate-bounce delay-100" />
          <Flame className="absolute top-0 -left-4 h-4 w-4 sm:h-5 sm:w-5 text-orange-400 animate-pulse" />
        </div>

        <CompletionHeader />
        <CompletionMessage />

        {/* Stats preview */}
        <div className="grid grid-cols-3 gap-2 sm:gap-3 py-2 sm:py-4">
          <div className="p-2 sm:p-3 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
            <p className="text-lg sm:text-2xl font-bold text-primary">100%</p>
            <p className="text-[10px] sm:text-xs text-muted-foreground">Completado</p>
          </div>
          <div className="p-2 sm:p-3 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
            <p className="text-lg sm:text-2xl font-bold text-foreground">🔥</p>
            <p className="text-[10px] sm:text-xs text-muted-foreground">En racha</p>
          </div>
          <div className="p-2 sm:p-3 rounded-xl bg-white/5 backdrop-blur-sm border border-white/10">
            <p className="text-lg sm:text-2xl font-bold text-green-400">+1</p>
            <p className="text-[10px] sm:text-xs text-muted-foreground">Entrenamiento</p>
          </div>
        </div>

        <div className="flex justify-center w-full">
          <Button
            onClick={handleCompletion}
            className="w-full max-w-sm mx-auto py-5 sm:py-6 text-base font-semibold bg-gradient-to-r from-primary to-primary/80 hover:from-primary/90 hover:to-primary/70 text-primary-foreground rounded-2xl shadow-xl shadow-primary/25 hover:shadow-primary/40 transition-all duration-300 hover:scale-[1.02] active:scale-[0.98]"
          >
            Volver al inicio
          </Button>
        </div>
      </div>
    </div>
  );
};
